import { SvgIconType } from './svg.interface';

const Play: SvgIconType = ({
  width = 9,
  height = 10,
  className = '',
  color = '#FFFFFF'
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 9 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.13943 5.64784L1.3779 9.59206C1.02011 9.80078 0.560876 9.67992 0.352166 9.32213C0.285256 9.20743 0.25 9.07702 0.25 8.94423L0.25 1.05579C0.25 0.641573 0.585786 0.305786 1 0.305786C1.13279 0.305786 1.2632 0.341042 1.3779 0.407952L8.13943 4.35217C8.49722 4.56088 8.61807 5.02012 8.40936 5.37791C8.34417 5.48966 8.25118 5.58265 8.13943 5.64784Z"
      fill={color}
    />
  </svg>
);

export default Play;
